
  <dx-data-grid 
                [dataSource]="dataSource"
                [rowAlternationEnabled]="true"
                [columnAutoWidth]="false"
                [showBorders]="true"
                [height]="420"
                (onEditorPrepared)="onEditorPrepared($event)"
                (onRowPrepared)="onRowPrepared($event)">
    
    <dxi-column [allowEditing]="false" dataField="Name" [caption]="ls.LNG('Label.Label')" [sortIndex]="0" sortOrder="asc" [width]="220"></dxi-column>
    <dxi-column dataField="EmployeeAssignedPrinterId" name="PrinterId" cellTemplate="printerNameTemplate" [caption]="ls.LNG('Label.Printer')">
      <dxo-lookup [dataSource]="printerDataSource"
                  valueExpr="PrinterId"
                  displayExpr="Name">
      </dxo-lookup>
    </dxi-column>
    <dxi-column [allowEditing]="false" dataField="SetupTypeCodes" dataType="string" [caption]="ls.LNG('Label.Source')"></dxi-column>
    <dxi-column [allowEditing]="false" cellTemplate="editButtonTemplate" [caption]="ls.LNG('Label.UserDefinedPrinter')" [width]="160" alignment="center"></dxi-column>

    <div *dxTemplate="let cell of 'printerNameTemplate'">
      <div *ngIf="cell.PrinterNames !== null">{{cell.data.PrinterNames}}</div>
      <div *ngIf="cell.PrinterNames === null" style="color:red;">{{ ls.LNG('Label.None').toUpperCase() }}</div>
    </div>

    <div *dxTemplate="let cell of 'editButtonTemplate'">
      <div class="tbl" style="margin: auto;">
        <div class="row">
          <div class="cell" [class.hidden]="cell.data.IsUserConfigured || cell.row.isEditing" title="{{ls.LNG('Label.Button.Edit')}}" style="padding-right: 7px;" (click)="onClickEditButton($event, cell, true)">
            <i style="font-size: 18px; padding-right: 0; padding-left: 0;" class="dx-icon-edit"></i>
          </div>
          <div class="cell" [class.hidden]="!cell.data.IsUserConfigured" style="padding-right: 7px;" (click)="onClickEditButton($event, cell, false)">
            <i style="font-size: 18px; padding-right: 0; padding-left: 0;" class="dx-icon-trash" title="{{ls.LNG('Label.Button.Delete')}}"></i>
          </div>
          <div class="cell" [class.hidden]="!cell.data.IsUserConfigured && !cell.row.isEditing || cell.data.IsUserConfigured" title="{{ls.LNG('Label.Button.Save')}}" style="padding-right: 7px;" (click)="onSaveClick(cell)" [attr.id]="'save_' + cell.data.PrintDefinitionId">
            <i style="font-size: 18px; " class="dx-icon-save"></i>
          </div>
          <div class="cell" [class.hidden]="!cell.data.IsUserConfigured && !cell.row.isEditing || cell.data.IsUserConfigured" title="{{ls.LNG('Label.Undo')}}" style="padding-right: 7px;" (click)="onClickAbortEditButton()" [attr.id]="'revert_' + cell.data.PrintDefinitionId">
            <i style="font-size: 18px;" class="dx-icon-revert"></i>
          </div>
        </div>
      </div>
    </div>

    <dxo-load-panel [enabled]="false"></dxo-load-panel>
  </dx-data-grid>



    
  
